import { NodeType } from '@cadet-dsl';
import { createEntityLayoutSpec, type EntityHeader, type EntitySpec } from '@snorf';
import { iString, IString, type IStringVariants } from '@strings';
import { immerable } from '@utils';
import { NodeSpec } from './NodeSpec';
import type { UnitLayout } from './UnitLayout';
import type { Doc } from './Doc';

/* ------------------------------------------------------------------ */
/*  Runtime data wrapper                                              */
/* ------------------------------------------------------------------ */
export class UnitSpec extends NodeSpec {
  [immerable] = true;

  declare layout?: UnitLayout;
  declare entitySpec: EntitySpec;

  constructor(doc: Doc, cls: string, attrs: Record<string, unknown>) {
    super(cls, NodeType.UNIT, attrs);

    this.entitySpec = entitySpecForClass(doc, cls);
    this.snorfSpec = createEntityLayoutSpec(this.entitySpec);
  }

  get title(): IString {
    return super.title;
  }

  set title(value: IString) {
    this.attrs.title = value;
    this.entitySpec.title = value;
  }
}

export function entitySpecForClass(doc: Doc, className: string): EntitySpec {
  const classAttrs = doc.classes.getFlattenedClassAttrs(className);
  const name = classAttrs.name as IStringVariants;
  let displayName = iString(name);
  if (displayName.isEmpty) {
    displayName = iString(className);
  }

  let header: EntityHeader | undefined;
  const backgroundColor = classAttrs.backgroundColor as string;
  let title = displayName;

  if (doc.classes.hasClass('Entity')) {
    if (doc.classes.isClassKindOf(className, 'Entity')) {
      title = iString('A');
      const headerColor = classAttrs.headerColor as string;
      header = {
        className: displayName,
        backgroundColor: headerColor
      };
    }
  }

  return {
    header,
    title,
    backgroundColor
  };
}
